export const hotkeyMap = {
  TOGGLE_HOTKEYS: ["meta+?, meta+ß", "ctrl+?, ctrl+ß"],
  OPEN_HOTKEY_CHEATSHEET: ["?", "shift+?", "shift+ß", "shift+/", "shift+7"],
  TOGGLE_MODERATION: "p",
  TOGGLE_READY_STATE: "d",
  TOGGLE_RAISED_HAND: "h",
  TOGGLE_BOARD_REACTION_MENU: "r",
  TOGGLE_TIMER_MENU: "t",
  TOGGLE_VOTING_MENU: "v",
  TOGGLE_SETTINGS: "s",
  TOGGLE_SHOW_AUTHORS: "alt+a",
  TOGGLE_SHOW_OTHER_USERS_NOTES: ["meta+u, ctrl+u"],
  TOGGLE_COLUMN_VISIBILITY: ["meta+j, ctrl+j"],
  SELECT_NOTE_INPUT_FIRST_KEY: ["option", "alt"], // They are treated the same, but both are included here for proper display in the UI
  SET_TIMER_FIRST_KEY: ["ctrl+t"],
};
